import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});
